import axiosinstance from "@/core/axios";
import GlobalConfig from "@/variable";

export default {
  /**
   * Do the login using one-time token
   * @param  token - token
   * @param  companyname - company name from querystring
   * @returns {string} success or error msg
   */
  doTokenLogin(token, companyname) {
    return axiosinstance.post(GlobalConfig.baseUrl + "user/tokenlogin", {
      token: token,
      company_url: companyname
    });
  },

  /**
   * Do the login using registered username and password
   * @param  username - email
   * @param  password - password
   * @param  companyname - company name from querystring
   * @param  invitecode - invite code from other user
   * @returns {string} success or error msg
   */
  doEmailLogin(username, password, companyname, invitecode, legacy) {
    return axiosinstance.post(GlobalConfig.baseUrl + "user/login", {
      email: username,
      password: password,
      company_url: companyname,
      invite_code: invitecode,
      legacy: legacy
    });
  },
  /**
   * Do SMS login with Phone number and Password
   * @param phone
   * @param password
   * @param companyname
   * @param legacy
   * @returns {*}
   */
  doSMSLogin (phone, password, companyname, legacy) {
    return axiosinstance.post(GlobalConfig.baseUrl + "user/sms-login", {
      phone: phone,
      password: password,
      company_url: companyname,
      legacy: legacy
    });
  },
  /**
   * Register to app by company
   * @param  username - email
   * @param  fullname - full name of the user
   * @param companyname - company name from querystring
   * @param invitecode - invite code from other user
   * @param password
   * @param legacy
   * @returns {string} success or error msg
   */
  doRegister(username, fullname, companyname, invitecode, password, legacy) {
    return axiosinstance.post(GlobalConfig.baseUrl + "user/signup", {
      email: username,
      name: fullname,
      company_url: companyname,
      invite_code: invitecode,
      password: password,
      legacy: legacy
    });
  },
  /**
   * Register via SMS
   * @param username
   * @param fullname
   * @param companyname
   * @param invitecode
   * @param password
   * @param legacy
   * @param confirmationcode
   * @returns {*}
   */
  doSMSRegister(username, fullname, companyname, invitecode, password, legacy, confirmationcode) {
    if (confirmationcode && confirmationcode.length > 0) {
      return axiosinstance.post(GlobalConfig.baseUrl + "user/sms-signup2", {
        phone: username,
        company_url: companyname,
        confirmationcode: confirmationcode,
        legacy: legacy
      });
    } else {
      return axiosinstance.post(GlobalConfig.baseUrl + "user/sms-signup1", {
        phone: username,
        name: fullname,
        company_url: companyname,
        invite_code: invitecode,
        password: password,
        legacy: legacy
      });
    }
  },
  /**
   * Do Fb login
   * @param  accesstoken - FB access token
   * @param companyname - company name from querystring
   * @param invitecode - invite code from other user
   * @param legacy
   * @returns { string } success or error msg
   */
  dofbApiLogin(accesstoken, companyname, invitecode, legacy) {
    return axiosinstance.post(GlobalConfig.baseUrl + "user/fblogin", {
      access_token: accesstoken,
      company_url: companyname,
      invite_code: invitecode,
      legacy: legacy
    });
  },
  /**
   * Do google login
   * @param  accesstoken - Google Acess token
   * @param companyname - company name from querystring
   * @param invitecode - invite code from other user *
   * @param legacy
   * @returns {string } success or error msg
   */
  doGoogleApiLogin(accesstoken, companyname, invitecode, legacy) {
    return axiosinstance.post(GlobalConfig.baseUrl + "user/google-login", {
      access_token: accesstoken,
      company_url: companyname,
      invite_code: invitecode,
      legacy: legacy
    });
  },
  /**
   * Refresh the access token when it expired
   * @param  refreshToken - Refresh token
   * @returns {JSON} access token with refresh token
   */
  doRefreshToken(refreshToken) {
    return axiosinstance.post(GlobalConfig.baseUrl + "user/getnewtoken", {
      refresh_token: refreshToken
    });
  },

  /**
   * Do the password change
   * @param  username - email
   * @param companyname - company name from querystring
   * @param legacy
   * @returns {string} Success or error msg
   */
  doPasswordChange(username, companyname, legacy) {
    return axiosinstance.post(GlobalConfig.baseUrl + "user/forgot-password", {
      email: username,
      company_url: companyname,
      legacy: legacy
    });
  },
  /**
   * Do the Phone password change
   * @param phone
   * @param companyname - company name from querystring
   * @param password
   * @param confirmation_code
   * @param legacy
   * @returns {string} Success or error msg
   */
  doPhonePasswordChange(phone, companyname, password, confirmation_code, legacy) {
    return axiosinstance.post(GlobalConfig.baseUrl + "user/forgot-phone-password", {
      phone: phone,
      company_url: companyname,
      password: password,
      confirmation_code: confirmation_code,
      legacy: legacy
    });
  }
};
